import React from 'react';
import PropTypes from 'prop-types';
import { InnerWrapper, Truncate } from './StyledTooltip';

const { string, node } = PropTypes;

/** */
const TooltipInner = props => {
  const { children, ariaDescribedById } = props;
  return (
    <InnerWrapper aria-describedby={ariaDescribedById}>
      <Truncate>{children}</Truncate>
    </InnerWrapper>
  );
};

TooltipInner.propTypes = {
  /**
   * Aria described by prop to be used in case validation messages.
   */
  ariaDescribedById: string,
  /**
   * This is the inner content of the Tooltip.
   */
  children: node
};

TooltipInner.defaultProps = {
  ariaDescribedById: undefined,
  children: null
};

export default TooltipInner;
